<template>
  <section class="section">
    <table-ag
      :if="processes"
      :rowData="processes"
      :columnDefs="columns"
      :components="components"
      :component-menu="componentMenu"
      :actions="true"
      :typeSelection="'single'"
      @selected="selected"
    ></table-ag>

    <!-- Components -->
    <transition name="slide">
      <MenuCreateProcess
        v-if="showMenuCreate"
        type="cl7"
        :data="processEdit"
        @closeMenuCreate="closeMenuCreate"
        @getProcesses="getProcesses"
      >
      </MenuCreateProcess>
    </transition>
    <ModalComparacion
      ref="modalCompClima"
      :show="showModalCom"
      :process="process"
      :listProcesses="processes"
      @closeModalComp="closeModalComp"
      @getProcesses="getProcesses"
      @selected="selected"
      @deleteComparison="deleteComparison"
    ></ModalComparacion>
  </section>
</template>
<script>
import apiServices from "@/services/yungol-services";
import tableAg from "../dashboard/tableAg.vue";
import { mapState } from "vuex";
import MenuCreateProcess from "../lideres/components/menuCreateProcess.vue";
import ModalComparacion from "../modals/ModalComparacion.vue";
import buttonsActionProcess from "../climan/components/buttonsActionProcess.vue";
import menuTableProcess from "../climan/components/menuTableProcess.vue";

export default {
  data() {
    return {
      processes: [],
      process: {},
      processEdit: {},
      columns: [
        {
          field: "nombre",
          headerName: "Proceso",
          editable: false,
          cellRenderer: (params) => {
            return `${this.formatTypeProcess(params)} ${params.value}`;
          },
        },
        {
          field: "comparison",
          headerName: "Comparación",
          cellRenderer: (params) => {
            return this.formatStatusComp(params.value);
          },
          editable: false,
          width: 60,
          cellStyle: {
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
            "padding-right": "5",
          },
          tooltipValueGetter: (params) => {
            return params.value ? params.value.nombre : null;
          },
        },
        {
          field: "codigo",
          headerName: "Código",
          editable: false,
          width: 20,
          cellStyle: {
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
            "padding-right": "5",
          },
        },
        {
          field: "created",
          headerName: "Creado",
          editable: false,
          cellRenderer: (params) => {
            return this.dateProcess(params.value);
          },
          width: 60,
          cellStyle: {
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
            "padding-right": "5",
          },
        },
        {
          field: "_id",
          headerName: "Controles",
          colId: "_actions",
          editable: false,
          width: 100,
          cellRenderer: "ButtonsActionProcessClim",
        },
      ],
      components: {
        ButtonsActionProcessClim: () => {
          return {
            render: (h) =>
              h(buttonsActionProcess, {
                props: {},
                on: {
                  editProcess: this.editProcess,
                  selectedComp: this.selectedComp,
                },
              }),
          };
        },
      },
      componentMenu: () => {
        return {
          render: (h) =>
            h(menuTableProcess, {
              props: {},
              on: {
                closeMenuCreate: this.closeMenuCreate,
              },
            }),
        };
      },
      showModalCom: false,
      showMenuCreate: false,
    };
  },
  computed: {
    ...mapState(["idtoken"]),
  },
  beforeMount() {},
  methods: {
    // Table
    async getProcesses() {
      try {
        const result = await apiServices.get(`/listcohorteclima`);
        if (result.data) {
          this.processes = result.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async selected(pro1, pro2) {
      if (pro2) {
        const newProcess = this.orderProcessSelection([pro1, pro2]);
        const result = await apiServices.post("saveCompProcessClima", {
          idProcess: newProcess[0]._id,
          idProcessComp: newProcess[1]._id,
        });

        if (result.data) {
          await this.$swal({
            html:
              "Comparación guardada correctamente. <br><br> Al proceso" +
              ` <span class="has-text-weight-bold">${newProcess[0].nombre}</span> ` +
              "se le asignó la comparación.",
            icon: "success",
          });
          pro1 = newProcess[0];
          pro2 = newProcess[1];
        } else {
          await this.$swal({
            text: "Error al guardar y comparar los dos procesos.",
            icon: "error",
          });
        }
      } else {
        if (pro1.comparison) {
          pro2 = pro1.comparison;
        } else {
          pro2 = {};
        }
      }
      this.$emit("selproceso", pro1, pro2);
    },
    selectedComp(proc) {
      this.process = proc;
      this.closeModalComp();
    },
    // Modals or Components
    closeModalComp() {
      this.showModalCom = !this.showModalCom;
    },
    closeMenuCreate() {
      this.showMenuCreate = !this.showMenuCreate;
      if (!this.showMenuCreate) this.processEdit = {};
    },
    async deleteComparison(id) {
      try {
        const result = await apiServices.delete(`procesoCompClima/${id}`);
        if (result.data) {
          await this.$store.dispatch("notify", {
            message: `Se elimino correctamente.`,
            type: "is-link",
          });
          await this.getProcesses();
          this.$refs.modalCompClima.close();
        }
      } catch (error) {
        await this.$store.dispatch("notify", {
          message: `No se elimino correctamente la comparación.`,
          type: "is-danger",
        });
      }
    },
    editProcess(data) {
      this.processEdit = data;
      this.closeMenuCreate();
    },
    // Helpers
    dateProcess(d) {
      let date = new Date(d);
      let options = { year: "numeric", month: "numeric", day: "numeric" };
      date = date.toLocaleDateString(undefined, options);
      return date;
    },
    formatTypeProcess(p) {
      if (p.data.test)
        return `<span class="tag tag-process is-success is-capitalized">Prueba</span>`;
      return "";
    },
    formatStatusComp(v) {
      if (v) {
        return `<span class="tag is-dark is-capitalized">Sí</span>`;
      } else {
        return `<span class="tag is-warning is-capitalized">No</span>`;
      }
    },
    orderProcessSelection(p) {
      return p.sort(
        (objA, objB) =>
          Number(new Date(objB.created)) - Number(new Date(objA.created))
      );
    },
  },
  created() {
    if (this.idtoken) {
      this.getProcesses();
    }
  },
  watch: {
    idtoken(nv, ov) {
      if (nv) {
        this.getProcesses();
      }
    },
  },
  components: {
    ModalComparacion,
    MenuCreateProcess,
    tableAg,
  },
};
</script>
<style lang="scss">
.ag-header-cell-label {
  justify-content: center !important;
}

.slide-enter {
  transform: translateX(30vw);
}

.slide-enter-active {
  transition: all 0.3s ease-in;
}

.slide-leave-active {
  transition: all 0.3s ease-in;
}
.slide-leave-to {
  transform: translateX(30vw);
}

.slide-two-enter {
  transform: translateX(30vw);
}

.slide-two-enter-active {
  transition: all 0.3s ease-in;
}

.slide-two-leave-active {
  transition: all 0.3s ease-in;
}
.slide-two-leave-to {
  transform: translateX(30vw);
}

.tag-process {
  font-size: 11px !important;
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/climan/Process.vue